export default __webpack_public_path__ + "static/media/3d825a1b.svg";